var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Group 8884",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0Z",
  "data-name": "Path 224"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#77777a",
  d: "M16.081 14.586h-.788l-.277-.269a6.492 6.492 0 1 0-.7.7l.269.279v.788l4.986 4.976 1.486-1.486Zm-5.983 0a4.487 4.487 0 1 1 4.487-4.487 4.48 4.48 0 0 1-4.487 4.487",
  "data-name": "Path 225"
})));
export { SvgSearch as ReactComponent };
export default "/_next/static/images/search.svg";